module.exports = __webpack_public_path__ + "static/energy-myths-and-realities-2babc927d0840b7211b1ee32581bb335.jpg";